import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconFacebook = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-facebook" data-icon="icon-facebook" aria-hidden="true" {...props} ref={ref}><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>);
});

IconFacebook.displayName = 'IconFacebook';
